import React, { Component } from 'react';
import { Input } from 'reactstrap';
import i18next from 'i18next';
class Enum extends Component {
    render() {
        return (<Input
            type='select'
            value={this.props.value}
            onChange={evt => {
                let val = evt.target.value;
                if (val === '') val = null;
                if (this.props.onChange) {
                    this.props.onChange(val);
                }
            }}>
            <option value=''>{i18next.t('pleaseChoose')}</option>
            {this.props.schema.items.map((item, index) =>
                <option value={item.value} key={index}>{item.key}</option>)}
        </Input>)
    }
}

export default Enum;